import CreateDepartmentForm from './CreateDepartmentForm';

export default CreateDepartmentForm;
